import { render, staticRenderFns } from "./Weather.vue?vue&type=template&id=8bf571a2&scoped=true&"
import script from "./Weather.vue?vue&type=script&lang=js&"
export * from "./Weather.vue?vue&type=script&lang=js&"
import style0 from "./Weather.vue?vue&type=style&index=0&id=8bf571a2&lang=scss&scoped=true&"
import style1 from "./Weather.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf571a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCarousel,VCarouselItem,VIcon})
